<!--
 * @Description: 申请退款
 * @Author:  wang.y
-->
<template>
  <van-popup v-model="modelIndex" position="bottom" round @close="clearForms">
    <div class="container-wrapper">
      <div class="line" @click="modelIndex = false"></div>
      <div class="container-top">
        <Form ref="apply-invoice" :model="currentForm" :rules="ruleValidate">
          <FormItem prop="reason" :label="'退款原因' | dealLanguage('Reason')">
            <Select v-model="currentForm.reason" :placeholder="'请选择退款原因' | dealLanguage('Please select a refund reason')">
              <Option v-for="item in reason_list" :value="item" :key="item">{{ item }}</Option>
            </Select>
          </FormItem>
          <FormItem :label="'退款金额' | dealLanguage('Amount')">
            <div class="ivu-input-wrapper ivu-input input-font">¥{{orderItem.paymentAmount}}</div>
          </FormItem>
          <FormItem prop="remark" :label="'退款备注' | dealLanguage('Notes')">
            <Input type="textarea" v-model="currentForm.remark" :placeholder="'请填写退款备注' | dealLanguage('Please fill in the refund note')"></Input>
          </FormItem>
        </Form>
      </div>
      <div class="container-bottom">
        <div class="tip">
            {{'退款申请通过后，将退款金额以原渠道退回。' | dealLanguage('After the refund application is approved, the refund amount will be returned through the original channel.')}}
          </div>
        <div class="btns-wrapper">
          <van-button type="warning" block @click="close">{{'取消' | dealLanguage('Cancel')}}</van-button>
          <van-button type="primary" block @click="applyInvoice">{{'提交' | dealLanguage('Submit')}}</van-button>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { ordercancel } from '@/service/vbef'
import { mapState } from 'vuex'
import filter from 'js/filter'
export default {
  data() {
    return {
      filter,
      orderItem: {},
      orderIndex: 0,
      modelIndex: false,
      buttonLoading: false,
      currentForm: {
        reason: '',
        remark: '',
      },
      ruleValidate: {
        reason: [{ required: true, message: filter.dealLanguage('请选择退款原因', 'Please select a refund reason'), trigger: 'change' }],
      },
      reason_list: [
        filter.dealLanguage('我不想要了', "I don't want it anymore"), 
        filter.dealLanguage('重复购买', 'Repeat purchase'), 
        filter.dealLanguage('行程安排有冲突', 'There is a conflict in the schedule'), 
        filter.dealLanguage('其他', 'Other')
      ],
    }
  },
  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      index2_path: (state) => state.index2_path,
      index_path: (state) => state.index_path,
      user_key: (state) => state.user_key,
      language: (state) => state.language,
    }),
  },
  methods: {
    close() {
      this.modelIndex = false
    },
    clearForms(value) {
      if (value) return
      this.$refs['apply-invoice'].resetFields()
    },
    applyInvoice() {
      this.$refs['apply-invoice'].validate(async (valid) => {
        if (valid) {
          this.buttonLoading = true
          this.currentForm.orderId = this.orderItem.id
          this.currentForm.userKey = this.user_key
          let res = await ordercancel(this.currentForm)
          this.buttonLoading = false
          if (res.code == 0) {
            this.$notify(this.language == 'zh' ? '申请成功！' : 'Application successful!')
            this.$emit('success', this.orderIndex)
            this.modelIndex = false
          } else {
            this.$notify(filter.dealLanguage(res.msg, res.enMsg || res.msg))
          }
        }
      })
    },
  },
  created() {},
  mounted() {},
}
</script>
<style lang="stylus" scoped>
@import '~styles/modal-form-m.styl'
</style>
